
export const CCTV_CHANGE_ACTIVE = "CCTV_CHANGE_ACTIVE";